import MainBody from "./components/MainRouter";
import React from "react";
import "./styles/App.css";

import { Route, Switch } from "react-router-dom";

import Layout from "./components/Layout";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { theme } from "./styles/theme";
import Login from "./Pages/register/Login";
import Register from "./Pages/register/Register";
import RTL from "./components/Rtl";
import { connect } from "react-redux";
import RegisterStages from "./Pages/register/RegisterStages";

import LoginRecovery from "./Pages/register/LoginRecovery";
import MessageHandler from "./components/MessageHandler";
import Store from "./redux/Store";
import { popupMessagesHandler } from "./redux/Orders/OrderActionCreators";

const App = ({ officeAuth }) => {
  let chanel = new BroadcastChannel("isOnline");
  chanel.addEventListener("message", (e) => {
    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: "اتصال به اینترنت را چک کنید",
        color: "error",
      })
    );
  });
  // --------------------------------------------------------------------------- routes
  let routes = [];
  [
    { path: "/", comp: Login, exact: true },
    { path: "/login/getCode", comp: LoginRecovery, exact: true },
    { path: "/register", comp: Register, exact: true },
    { path: "/register/stages", comp: RegisterStages, exact: true },
  ].forEach((route, index) => {
    routes.push(
      <Route exact={route.exact} path={`${route.path}`} key={index}>
        <route.comp />
      </Route>
    );
  });

  return (
    <RTL>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {!localStorage.token ? (
          <Switch>
            <>{routes}</>
          </Switch>
        ) : (
          <Layout>
            <MainBody />
          </Layout>
        )}
        <MessageHandler />
      </ThemeProvider>
    </RTL>
  );
};

const mapStateToProps = (props) => {
  let { loginReducer } = props;
  let { officeAuth, pwa_install } = loginReducer;

  return { officeAuth, pwa_install };
};
export default connect(mapStateToProps)(App);
